<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF USER MANAGEMENT</b></h5>
    <hr />
    <TableUserIndex
      :fields="fields.fields"
      :filter="this.filter"
      :page="this.page"
      :name="this.name"
      :state="this.state"
      :access_lvl="this.access_lvl"
      :email="this.email"
    />
  </b-card>
</template>

<script>
import TableUserIndex from "@/table/admin/user/TableUserIndex";

export default {
  data() {
    return {
      items: [],

      filter: "",
      page: "",
      name: "",
      state: "",
      access_lvl: "",
      email: "",

      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Role",
            key: "role",
            sortable: true
          },
          {
            label: "State",
            key: "state",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },
  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.name = this.$route.query.name;
      this.state = this.$route.query.state;
      this.access_lvl = this.$route.query.access_lvl;
      this.email = this.$route.query.email;
    }
  },
  methods: {
    getUser() {
      this.$store.dispatch("getUser").then(res => {
        let no = 0;
        res.data.data.forEach(element => {
          let role = "";
          let state = "";
          no = no + 1;

          if (element.role_details !== null) {
            role = element.role_details.desc;
          }
          if (element.state_details !== null) {
            state = element.state_details.desc;
          }
          this.items.push({
            no: no,
            name: element.name,
            role: role,
            state: state,
            id: element.user_id
          });
        });
        this.totalRows = this.items.length;
      });
    }
  },
  components: {
    TableUserIndex
  }
};
</script>
<style lang="css" scoped></style>
